import React, { useState } from "react";
import { Row, Col, Timeline, Modal } from "antd";
import styles from "../DashBoard/DashBoardMobile/DashBoardMobile.module.scss";
import commonStyles from "../DashBoard/DashBoard.module.scss";
import DashBoardGmaps from "../DashBoard/DashBoardGmaps";
import { ITripDetails } from "../ServiceUsers/Interfaces/ITripDetails";
import moment from "moment";
import getTripIcon from "../../helpers/getTripIcon";
import {
  dropoffTimelineIcon,
  homeIcon,
  pickupTimelineIcon,
} from "../../assets/images";

type Props = {
  trip: ITripDetails;
};

const ServiceUserTripDetailsMobile: React.FC<Props> = ({ trip }) => {
  const [isMapModalOpen, setIsMapModalOpen] = useState<boolean>(false);

  const serviceDetailRow = (
    leftHeading: string,
    leftContent: string,
    rightHeading: string,
    rightContent: string
  ): JSX.Element => {
    return (
      <Row className={styles.serviceDetailsRows}>
        <Col span={12}>
          <Row>
            <Col span={24} className={styles.detailsHeading}>
              {leftHeading}
            </Col>
            <Col span={24} className={styles.detailsInfo}>
              {leftContent}
            </Col>
          </Row>
        </Col>
        <Col span={12}>
          <Row>
            <Col span={24} className={styles.detailsHeading}>
              {rightHeading}
            </Col>
            <Col span={24} className={styles.detailsInfo}>
              {rightContent}
            </Col>
          </Row>
        </Col>
      </Row>
    );
  };

  return (
    <>
      {serviceDetailRow(
        "Date",
        moment(trip?.tripDate).format("MM/DD/YYYY"),
        "Time",
        trip?.isWillCall
          ? "Call when ready"
          : moment(trip?.appointmentTime || trip?.requestPickTime).format(
              "HH:mm A"
            )
      )}

      <Row className={styles.serviceDetailsRows}>
        <Col span={12}>
          <Row>
            <Col span={24} className={styles.detailsHeading}>
              Service Type
            </Col>
            <Col span={24} className={styles.serviceTypeDetailsAlign}>
              <span className={styles.tripImageSmall}>
                {getTripIcon(trip?.tripReason)}
              </span>
              <span className={styles.detailsInfo}>{trip?.typeOfService}</span>
            </Col>
          </Row>
        </Col>
        <Col span={12}>
          <Row>
            <Col span={24} className={styles.detailsHeading}>
              Service User
            </Col>
            <Col span={24} className={styles.detailsInfo}>
              {trip?.serviceUser}
            </Col>
          </Row>
        </Col>
      </Row>

      {serviceDetailRow(
        "Cost",
        `$${trip?.tripCost}`,
        "Status",
        trip?.statusDetail
      )}

      <div className={styles.mobileMapsContainer}>
        <Row align="middle" justify="center">
          <Col
            xs={{ span: 4, offset: 2 }}
            sm={{ span: 4, offset: 4 }}
            md={{ span: 4, offset: 6 }}
            className={commonStyles.distanceText}
          >
            <Row
              justify="end"
              align="middle"
              className={commonStyles.distanceMargin}
            >
              <Col>{trip?.providerDistance} mi</Col>
            </Row>
          </Col>
          <Col xs={18} sm={16} md={14} className={commonStyles.customTimeline}>
            <Timeline>
              <Timeline.Item dot={<img src={pickupTimelineIcon} />}>
                <Row>
                  <Col span={24} className={commonStyles.addressHeading}>
                    Pickup Address
                  </Col>
                  <Col span={24} className={commonStyles.addressDetails1}>
                    <img src={homeIcon} alt="pickup address" />
                    <span>{trip?.pickUpAddress1}</span>
                  </Col>
                  <Col span={24} className={commonStyles.addressDetails2}>
                    {trip?.pickUpCity}, {trip?.pickUpState}{" "}
                    {trip?.pickUpZipCode}
                  </Col>
                </Row>
              </Timeline.Item>
              <Timeline.Item dot={<img src={dropoffTimelineIcon} />}>
                <Row>
                  <Col span={24} className={commonStyles.addressHeading}>
                    Dropoff Address
                  </Col>
                  <Col span={24} className={commonStyles.addressDetails1}>
                    {trip?.dropOffAddress1}
                  </Col>
                  <Col span={24} className={commonStyles.addressDetails2}>
                    {trip?.dropOffCity}, {trip?.dropOffState}{" "}
                    {trip?.dropOffZipCode}
                  </Col>
                </Row>
              </Timeline.Item>
            </Timeline>
          </Col>
        </Row>

        <DashBoardGmaps
          setIsMapModalOpen={setIsMapModalOpen}
          tripDetails={trip}
          width={"auto"}
          height="167px"
          isCalling="mobile"
        />
      </div>

      {serviceDetailRow(
        "Pickup Instructions",
        trip?.pickupNotes,
        "Dropoff Instructions",
        trip?.dropNotes
      )}

      {serviceDetailRow("Trip ID", trip?.tripId, "Booking ID", trip?.bookingId)}

      <Modal
        visible={isMapModalOpen}
        footer={null}
        className={styles.expandedMap}
      >
        <DashBoardGmaps
          isMapModalOpen={isMapModalOpen}
          setIsMapModalOpen={setIsMapModalOpen}
          tripDetails={trip}
          width={"auto"}
          height={"458px"}
          isCalling="mobile"
        />
      </Modal>
    </>
  );
};

export default ServiceUserTripDetailsMobile;
